import { render, staticRenderFns } from "./custom_table.vue?vue&type=template&id=767ddb12&scoped=true"
import script from "./custom_table.vue?vue&type=script&lang=js"
export * from "./custom_table.vue?vue&type=script&lang=js"
import style0 from "./custom_table.vue?vue&type=style&index=0&id=767ddb12&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767ddb12",
  null
  
)

export default component.exports